module.exports = require('./lib/patch')



//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/patch.js
// module id = 5
// module chunks = 0